module.exports = __webpack_public_path__ + "media/click_03.6d8ed539.wav";